"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.failureApplicationList = exports.successApplicationList = exports.loadingApplicationList = exports.requestApplicationList = void 0;

var _constants = require("./constants");

var requestApplicationList = function requestApplicationList() {
  return {
    type: _constants.ApplicationsListTypes.APPLICATION_LIST_REQUEST
  };
};

exports.requestApplicationList = requestApplicationList;

var loadingApplicationList = function loadingApplicationList() {
  return {
    type: _constants.ApplicationsListTypes.APPLICATION_LIST_LOADING
  };
};

exports.loadingApplicationList = loadingApplicationList;

var successApplicationList = function successApplicationList(ApplicationsList) {
  return {
    type: _constants.ApplicationsListTypes.APPLICATION_LIST_SUCCESS,
    payload: ApplicationsList
  };
};

exports.successApplicationList = successApplicationList;

var failureApplicationList = function failureApplicationList(reason) {
  return {
    type: _constants.ApplicationsListTypes.APPLICATION_LIST_FAILURE,
    payload: {
      error: reason
    }
  };
};

exports.failureApplicationList = failureApplicationList;